import { render, staticRenderFns } from "./lock-prescription-dialog.vue?vue&type=template&id=6167831b&scoped=true&lang=pug&"
import script from "./lock-prescription-dialog.vue?vue&type=script&lang=ts&"
export * from "./lock-prescription-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./lock-prescription-dialog.vue?vue&type=style&index=0&id=6167831b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167831b",
  null
  
)

export default component.exports